import React from 'react';
import '../styles/404.css';

const NotFound = () => (
  <div
    className="not-found-page-container"
    style={{
      backgroundImage: 'url("/images/404.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
    }}
  >
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="nt-group mb-32 ml-32">INT. 404 - DAY</div>

        <div className="nt-group nt-group-wide">
          <div className="nt-group-numbers">
            1
            <br />
            2
            <br />
            3
            <br />
          </div>
          <div className="flex nt-gap">
            <div className="nt-group-text">
              <p>Couldn&apos;t find the page that you were looking for.</p>
            </div>
            <div className="nt-group-text">
              <p>Unless you were looking for this page, which i highly doubt.</p>
            </div>
          </div>
        </div>

        <svg width="177" height="14" viewBox="0 0 177 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="113" y="0.320007" width="1.92" height="13.44" fill="white" />
          <rect x="124.52" y="0.320007" width="1.92" height="13.44" fill="white" />
          <rect x="142.439" y="0.320007" width="1.92" height="13.44" fill="white" />
          <rect x="135.4" y="4.79999" width="1.92" height="8.96" fill="white" />
          <rect x="150.76" y="6.08002" width="1.92" height="7.68" fill="white" />
          <rect x="146.92" y="0.320007" width="1.92" height="5.12" fill="white" />
          <rect width="1.92" height="5.12" transform="matrix(-1 0 0 1 156.52 0.320007)" fill="white" />
          <rect x="147.561" y="4.79999" width="1.92" height="1.92" fill="white" />
          <rect width="1.92" height="1.92" transform="matrix(-1 0 0 1 155.881 4.79999)" fill="white" />
          <rect x="148.84" y="5.44" width="1.92" height="2.56" fill="white" />
          <rect width="1.92" height="2.56" transform="matrix(-1 0 0 1 154.6 5.44)" fill="white" />
          <path d="M164.841 13.44H163.561V0H164.841V0.96H165.481V1.28H167.081V2.24H168.681V3.2H170.921V4.16H172.841V5.12H175.081V6.08H177.001V7.36H175.081V8.32H172.841V9.28H170.921V10.24H168.681V11.2H167.081V12.16H165.481V12.48H164.841V13.44Z" fill="white" />
          <rect x="114.92" y="0.320007" width="5.12" height="1.92" fill="white" />
          <rect x="118.76" y="0.960022" width="2.56" height="1.92" fill="white" />
          <rect x="119.4" y="1.59998" width="2.56" height="5.12" fill="white" />
          <rect x="118.76" y="5.44" width="2.56" height="1.92" fill="white" />
          <rect x="114.92" y="6.08002" width="5.12" height="1.92" fill="white" />
          <rect x="125.801" y="11.84" width="7.04" height="1.92" fill="white" />
          <rect x="136.68" y="7.35999" width="7.04" height="1.92" fill="white" />
          <rect x="139.881" y="0.320007" width="4.48" height="1.92" fill="white" />
          <rect x="138.6" y="0.960022" width="1.92" height="2.56" fill="white" />
          <rect x="137.32" y="2.23999" width="1.92" height="2.56" fill="white" />
          <rect x="136.039" y="3.52002" width="1.92" height="2.56" fill="white" />
        </svg>

        <div className="nt-group nt-group-wide mb-24">
          <div className="nt-group-numbers">
            4
            <br />
            5
            <br />
            6
            <br />
          </div>
          <div className="flex nt-gap">
            <div className="nt-group-text">
              <p>anyways...</p>
            </div>
            <div className="nt-group-text">
              <p>there&apos;s plenty of other good pages around here.</p>
            </div>
          </div>
        </div>

        <div className="nt-group nt-group-wide mb-24">
          <div className="nt-group-numbers">
            7
            <br />
            8
            <br />
            9
            <br />
            10
          </div>
          <div className="flex nt-gap">
            <div className="nt-group-text">
              <p>
                Photo credit
                <br />
                Geronimo Giqueaux
                <br />
                @ggiqueaux -
                <br />
                Unsplash
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default NotFound;
